import {
    PARSER_STATISTIC_ERROR,
    PARSER_STATISTIC_SUCESS,
    PARSER_STATISTIC_REQUEST 
} from '../actions/dashboardParserActions';

const initialState={
    data:[],
    fetching:false,
    set:false,
}

export default function dashboardParser(state = initialState, action){
    switch (action.type){
        case PARSER_STATISTIC_REQUEST:
            return{
                ...state,
                fetching:true
            }
        case PARSER_STATISTIC_ERROR:
            return{
                ...state,
                fetching:false,
            }
        case PARSER_STATISTIC_SUCESS:
            return{
                ...state,
                fetching:false,
                set:true,
                data:action.payload
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/dashboardParser.js